export const theme = {
  background: "#fff",
  primary: "#27FF04",
  white: "#F4F4F4",
  darkGray: "#424242",
  lightGray1: "#7E7E7E",
  lightGray2: "#CCCCCC",
  darkDarkGray: "#272727",
  error: "#DE3B3B"
};

export type ITheme = typeof theme;
